 <div class="p-g page-header" *ngIf="headerHidden">
  <div class="p-g-12 p-md-6 p-lg-6 pl-0">
    <h1 #input tabindex="0" id="input" class="page-title">{{headerStr}}</h1>
  </div>
  <div class="p-g-12 p-md-6 p-lg-6 pr-0">
    <div  class="bread-crumbs pr-0">
      <li class="bread-item" *ngFor='let bread of breadCrumbArray; let index=index'>
        <a *ngIf="bread.name.length" href="{{bread.url}}"> &nbsp;{{bread.name}}</a> <label *ngIf="(index+1)!==breadCrumbArray.length"> > </label></li>
    </div>
  </div>
</div>
<p-toast position="top-right"></p-toast>
